/* Imports needed for all question form subclasses. */
import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import {
    mapStateToQuestionFormBaseProps,
    mapDispatchToQuestionFormBaseProps
} from '../../QuestionFormBase';

import {
    QuestionFormWithOptionsBase,
    QuestionFormWithOptionsBaseProps,
    QuestionFormWithOptionsBaseStates
} from '../QuestionFormWithOptionsBase';
import NotifyHOC from '../../../../../../HOC/Notifications';
import { MULTIMEDIA_TYPES, QTYPES } from '@nexxt/common/types';

/* Components used in this question form. */
import BuilderHeader from '../../../common/builderHeader';
import OptionSetting from '../../../common/optionSetting';
import QuestionSettings from '../../../common/questionSettings';
import UploadImage from '../../../common/uploadMedia/uploadimage';
import MediaLibraryAddModal from '../../../../../libraries/mediaLibrary/MediaLibraryAddModal';
import Settings from '../../../common/settingsBox';
import PipeOptionModal from '../../../common/pipeOptionModal';
import Loader from '../../../../../common/Loader/Loader';
import PipeOption from '../../../common/pipeOption';
import OptionPackModal from '../../../../../libraries/optionpack/OptionPackModal';
import SaveFooter from '../../../common/formFooter';
import MultimediaBubble from '../../../common/MultimediaBubble';

export interface Props extends QuestionFormWithOptionsBaseProps {
    // nothing special... yet!
}

export interface States extends QuestionFormWithOptionsBaseStates {
    // nothing special... yet!
}

class AdBuilder extends QuestionFormWithOptionsBase<Props, States> {
    constructor(p: QuestionFormWithOptionsBaseProps) {
        super(p, QTYPES.AD_BUILDER);
        const question = { ...this.state.question, showContinueButton: true };

        this.state = {
            ...this.state,
            question
        };
    }

    render() {
        const { currentProject } = this.props;
        const {
            question,
            showCardSettings,
            isOptionSettingsOpen,
            isSettingBoxLayoutOpen,
            isPipeOptionModalOpen,
            isOptionPackModalOpen
        } = this.state;
        const questionError =
            (this.state.showError && this.state.questionError) || {};

        return (
            <React.Fragment>
                {this.state.isMediaLibraryOpen && (
                    <MediaLibraryAddModal
                        isOpen={this.state.isMediaLibraryOpen}
                        setSelectedMedia={this.selectMedia}
                        notify={this.props.notify}
                        onCancel={this.closeMediaLibrary}
                        onClose={this.closeMediaLibrary}
                        type={'image'}
                        showMediaLibrary={true}
                    />
                )}
                <div>
                    <div className="project-add--question-builder">
                        {isPipeOptionModalOpen && (
                            <PipeOptionModal
                                isOpen={isPipeOptionModalOpen}
                                onClose={this.togglePipeOptionModal}
                                setSelectedPipeOption={this.setQuestion}
                                value={this.state.question.pipingQuestions}
                                showRandomize={this.state.question.random}
                            />
                        )}

                        {isOptionPackModalOpen && (
                            <OptionPackModal
                                isOpen={isOptionPackModalOpen}
                                onCancel={this.toggleOptionPackModal}
                                onDone={this.onSelectOpenPack}
                            />
                        )}

                        <BuilderHeader
                            toggleSettingBoxLayout={this.toggleSettingBoxLayout}
                            isSettingBoxLayoutOpen={isSettingBoxLayoutOpen}
                            showAlert={!this.props.editEnabled}
                            alertMessages={this.getWarningMessage()}
                            question={question}
                            setValue={this.setQuestion}
                            errorObject={this.state.questionError}
                        />
                        <div className="builder-body">
                            {(isSettingBoxLayoutOpen && (
                                <QuestionSettings
                                    onClose={this.toggleSettingBoxLayout}
                                    question={question}
                                    questionSettings={{
                                        allowUserEdit: true
                                    }}
                                    setValue={this.setQuestion}
                                    disabled={!this.props.editEnabled}
                                />
                            )) ||
                                null}
                            {this.renderErrorNotes()}
                            <MultimediaBubble
                                question={question}
                                languages={currentProject.languages}
                                setValue={this.setQuestion}
                                setValueWithLanguage={
                                    this.NEW_setQuestionTextTranslation
                                }
                                addNewBubble={this.NEW_addNewEditor}
                                removeBubble={this.NEW_removeEditor}
                                disabled={!this.props.editEnabled}
                                questionError={questionError}
                                settings={{ showClose: true }}
                            />
                            <div className="option-settings-block">
                                <div className="form-group-header display-flex">
                                    Options
                                    <Settings
                                        label="Option settings"
                                        onClick={this.toggleOptionSettings}
                                    />
                                </div>
                                <UploadImage
                                    image={question.mediaURL || ''}
                                    error=""
                                    label="Upload Image"
                                    onEdit={this.toggleMediaLibrary('image')}
                                    toggleImageModal={(img) =>
                                        this.toggleImageModal(img)
                                    }
                                    disabled={!this.props.editEnabled}
                                />
                                {isOptionSettingsOpen &&
                                    ((
                                        <OptionSetting
                                            setValue={this.setQuestion}
                                            question={question}
                                            settings={{
                                                showOptionsInARow: true,
                                                showOptionsLayout: true,
                                                showOptionType: true,
                                                showImageDisplay: true,
                                                showOptionNotApplicable: true,
                                                showRandomizeOption: true,
                                                showAliginOption: true,
                                                showMinMax: true,
                                                showPipingOptions: true,
                                                showIsEnableRichText: false
                                            }}
                                            toggleOptionSettings={
                                                this.toggleOptionSettings
                                            }
                                            onSaveOptionSettings={
                                                this.onSaveOptionSettings
                                            }
                                            optionSettingErrors={
                                                this.state
                                                    .optionSettingErrors || {}
                                            }
                                            disabled={!this.props.editEnabled}
                                        />
                                    ) ||
                                        null)}
                                {/* TODO: Change this markup */}
                                {(questionError &&
                                    (questionError.options || {})
                                        .isEmptyOptions && (
                                        <div
                                            className={` form-group ${
                                                questionError ? 'error' : ''
                                            }`}
                                        >
                                            <label className="form-group__label form-group__label--block">
                                                {
                                                    questionError.options
                                                        .isEmptyOptions
                                                }
                                            </label>
                                        </div>
                                    )) ||
                                    null}
                                {/** Show Option Add Button as well as Pipe Option Button  */}
                                {this.state.question.piping &&
                                this.state.question.pipingQuestions.length >
                                    0 ? (
                                    <div className="row">
                                        <div className="col-md-12">
                                            Piped option
                                            <PipeOption
                                                options={
                                                    this.state.question
                                                        .pipingQuestions
                                                }
                                                handlePipeOptionFields={
                                                    this.handlePipeOptionFields
                                                }
                                                question={this.state.question}
                                                showRandomize={
                                                    this.state.question.random
                                                }
                                            />
                                        </div>
                                    </div>
                                ) : null}
                                {/** Show Option Cards according to option type */}
                                {showCardSettings && this.renderOptionCard()}{' '}
                                {this.renderOptionAddButton()}{' '}
                                {/* <FollowUpQuestion
                              languages={currentProject.languages}
                              question={question}
                              setValue={this.setQuestionWithLanguage}
                              show={true}
                              questionError={questionError}
                          /> */}
                                {(question.showNotApplicableOption && (
                                    <MultimediaBubble
                                        languages={currentProject.languages}
                                        question={question}
                                        setValue={this.setQuestion}
                                        setValueWithLanguage={
                                            this.NEW_setQuestionTextTranslation
                                        }
                                        questionError={questionError}
                                        keyName="notApplicableTexts"
                                        disabled={!this.props.editEnabled}
                                        disableAddBubble
                                        defaultTextType={MULTIMEDIA_TYPES.TEXT}
                                        questionText="Not Applicable text"
                                        defaultText="BUTTON.NOT_APPLICABLE"
                                        settings={{
                                            noBorder: true,
                                            useTranslation: true
                                        }}
                                    />
                                )) ||
                                    null}
                                <MultimediaBubble
                                    languages={currentProject.languages}
                                    question={question}
                                    setValue={this.setQuestion}
                                    setValueWithLanguage={
                                        this.NEW_setQuestionTextTranslation
                                    }
                                    questionError={questionError}
                                    keyName="continueTexts"
                                    disabled={!this.props.editEnabled}
                                    disableAddBubble
                                    defaultTextType={MULTIMEDIA_TYPES.TEXT}
                                    questionText="Continue button text"
                                    defaultText="BUTTON.CONTINUE"
                                    settings={{
                                        noBorder: true,
                                        useTranslation: true
                                    }}
                                />
                            </div>
                        </div>
                        {/* end of builder-body */}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(
    NotifyHOC(
        connect(
            mapStateToQuestionFormBaseProps,
            mapDispatchToQuestionFormBaseProps
        )(AdBuilder)
    )
);
